// extracted by mini-css-extract-plugin
export default {"imageWrapper":"xG-z","twoColumnImage":"yG-z"};